import { Link, useLocation } from "wouter";
import { useAuth } from "@/hooks/useAuth";
import {
  LayoutDashboard,
  FileText,
  FolderOpen,
  MessageSquare,
  Users,
  LogOut,
  Menu,
  X,
  Inbox,
} from "lucide-react";
import { useState } from "react";

function UpsiteLogo({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="172 168.9 1169 336.1" className={className}>
      <path fill="white" d="M921 168.9c-4.6 1.5-8.5 3.9-11.6 7.3-5.3 5.5-6.8 9.5-6.8 17.3 0 7.8 1.5 11.8 6.8 17.3 5.2 5.6 10.1 7.6 18.1 7.6 8 0 12.9-2 18.1-7.6 5.3-5.5 6.8-9.5 6.8-17.3 0-10.1-4.8-18-13.8-22.7-4.3-2.2-13.6-3.2-17.6-1.9zM1014 201.5V234h-28v37h27.9l.3 72.2c.4 81.1 0 76.9 7.9 88.6 4.8 7.3 12.8 13 22 15.8 9.8 2.9 31.4 2.6 42.9-.8l8.5-2.4.3-17.9c.1-9.9 0-18.5-.2-19.1-.4-.9-2.1-.7-6.8.8-3.9 1.3-9.3 2.1-14.3 2.2-9.1.1-12.9-1.5-16.1-6.8-1.8-2.9-1.9-6.5-2.2-67.9l-.3-64.7h40.1v-37h-40v-65h-42v32.5zM541.5 231c-10.3 1.6-24.9 6.9-33.7 12.3-4.9 3-12.1 8.8-17.5 14.2l-9.3 9V234h-79v37h36v110.5l20.9-20.9 20.8-20.8.7-6.7c2.8-30.5 24.5-57.2 51.7-63.6 8.5-2 25.4-1.9 33.2.1 18.6 4.8 33.3 17 41.8 34.9 5.3 11.1 7 18.1 7.6 32 1.3 31.9-12.5 58.5-36.7 70.4-30.4 14.9-68 5.9-85.6-20.6l-3.7-5.5-25.3 25.3-25.4 25.4V505h-39v37h123v-37h-41v-83l8.7 7c20.4 16.5 46.3 25.2 70.8 23.7 26.6-1.7 49-12.1 67.7-31.5 21.8-22.6 31.9-51.2 30.5-86.1-1.3-32.5-12.4-58.5-33.4-78.1-17.7-16.6-39.8-25.5-65.8-26.5-6.6-.2-14.7 0-18 .5zM739.8 231.1c-22.8 3.3-42.2 14.6-52.4 30.6-4.3 6.7-8.1 18-8.9 26.8-1.3 14.1 4.6 31.7 14.4 42.7 14.1 15.7 31.5 22.9 71.8 29.8 29.7 5.1 36.8 7.7 42.4 15.8 2 3 2.4 4.8 2.4 11.2 0 6.8-.3 8.1-2.9 11.8-7.5 10.9-28 16.9-48.5 14.3-24.9-3.2-40.4-16-41.9-34.9l-.5-6.2-18.6.2-18.6.3v73l18.8.3 18.7.2v-12l4.9 3.1c21.5 13.2 59.4 15.8 87.9 6 11.4-4 18.4-8.3 27.2-17.1 12.7-12.6 17.5-25.5 16.7-44.5-1.3-32.5-20.6-52.5-58.7-61.1-5.8-1.3-18.1-3.5-27.5-4.9-22.1-3.3-28.7-4.9-36.3-8.6-9.8-4.8-13.5-12.2-11.1-22.2 1.8-7.6 9.3-14.8 18.3-17.6 23.9-7.4 49.2-.2 63.6 18 3.7 4.7 4 5.5 4 11.5v6.4h37v-70h-37v7.9l-6.9-2.9c-18.4-7.6-40.3-10.6-58.3-7.9zM1203.3 232.4c-23.6 3.9-46.3 16.2-63.7 34.6-23.8 25.2-33.1 60.5-26 98.1 5.3 28.2 20.3 50.2 45.7 67 29.8 19.6 71.4 24.5 108.7 12.7 19.2-6.1 33.5-14.2 45.9-26.2 7.1-6.9 17.1-19 17.1-20.8 0-.5-1.9-1.7-4.2-2.7-2.4-1-10.4-4.6-17.9-7.9l-13.6-6-4.3 5.5c-9.4 12-25.4 22.2-41.5 26.4-11.3 2.9-30.9 3-41.8 0-12.1-3.2-21-8.4-29.9-17.3-6.5-6.5-8.6-9.5-12.7-18.1-7.1-14.6-8.5-22.1-7.8-41.5.4-11.7 1.1-17.5 2.6-22.7 7.2-24.2 23.9-41.4 45.6-47 7.6-1.9 24.1-1.9 32.4 0 19.5 4.6 38.6 21.9 47.2 42.4 1.5 3.6 3 8.1 3.4 9.8l.7 3.3H1194v36h138.3l-.7-10.8c-3.1-47.5-17.9-75.9-51.4-97.9-17.1-11.3-35.4-17.1-56.2-17.8-7.8-.3-15.6.1-20.7.9z" />
      <path fill="white" d="M172 252.5V271h30v56.7c0 31.3.5 61.6 1 67.6 3.5 36.5 22.6 54.6 57.8 54.7 20.6 0 44.5-8.6 63.9-23.1 2.9-2.1 5.5-3.9 5.8-3.9.3 0 .5 5.4.5 12v12h41.5l18.3-18.3c10-10 18.2-18.6 18.2-19 0-.4-8.1-.7-18-.7h-18V234h-42v152l-5.5 4.3c-11.3 8.9-27.2 17.1-39.7 20.4-8.4 2.3-23.2 2.3-27.3.1-6.8-3.6-10.8-9.6-12.5-18.9-.6-3-1-29.1-1-63V271h30v-37H172v18.5zM873 252.5V271h34v138l-16.7.2-16.8.3v37h110v-37l-16.7-.3-16.8-.2V234h-77v18.5z" />
    </svg>
  );
}

const navItems = [
  { href: "/admin", label: "Dashboard", icon: LayoutDashboard },
  { href: "/admin/blog-posts", label: "Blog Posts", icon: FileText },
  { href: "/admin/projects", label: "Projects", icon: FolderOpen },
  { href: "/admin/testimonials", label: "Testimonials", icon: MessageSquare },
  { href: "/admin/clients", label: "Clients", icon: Users },
  { href: "/admin/leads", label: "Leads", icon: Inbox },
];

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const [location] = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    window.location.href = "/admin/login";
  };

  return (
    <div className="min-h-screen bg-[#0B1120] flex" dir="ltr">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#0F172A] border-r border-white/5 flex flex-col transition-transform lg:translate-x-0 lg:static ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="p-6 border-b border-white/5 flex items-center justify-between">
          <Link href="/admin" className="flex items-center gap-2">
            <UpsiteLogo className="h-7 w-auto" />
            <span className="text-sm font-medium text-white/50">admin</span>
          </Link>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden text-white/50 hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => {
            const isActive =
              item.href === "/admin"
                ? location === "/admin"
                : location.startsWith(item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setSidebarOpen(false)}
                className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#66CDAA]/10 text-[#66CDAA]"
                    : "text-white/50 hover:text-white hover:bg-white/5"
                }`}
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/5">
          <div className="flex items-center justify-between px-4 py-2">
            <span className="text-sm text-white/50">{user?.username}</span>
            <button
              onClick={handleLogout}
              className="text-white/30 hover:text-red-400 transition-colors"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 min-h-screen">
        {/* Top bar */}
        <div className="sticky top-0 z-30 bg-[#0B1120]/80 backdrop-blur-md border-b border-white/5 px-6 py-4 flex items-center gap-4 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-white/50 hover:text-white"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2">
            <UpsiteLogo className="h-6 w-auto" />
            <span className="text-xs font-medium text-white/50">admin</span>
          </div>
        </div>

        <div className="p-6 lg:p-8">{children}</div>
      </main>
    </div>
  );
}
